import { AlertTriangle, HelpCircle, Loader2 } from 'lucide-react'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { Modal } from './Modal'

export type ConfirmModalProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description?: ReactNode
  confirmLabel?: string
  cancelLabel?: string
  loading?: boolean
  destructive?: boolean
  onConfirm: () => void | Promise<void>
  children?: ReactNode
}

export function ConfirmModal({ open, onOpenChange, title, description, confirmLabel, cancelLabel, loading, destructive, onConfirm, children }: ConfirmModalProps) {
  const { t } = useTranslation()
  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      size="xs"
      variant="alert"
      dismissible={!loading}
      title={title}
      icon={destructive ? <AlertTriangle /> : <HelpCircle />}
      tone={destructive ? 'destructive' : 'default'}
      description={description}
      footer={
        <>
          <Button type="button" variant="cancel" onClick={() => onOpenChange(false)} disabled={loading}>
            {cancelLabel ?? t('common.cancel')}
          </Button>
          <Button type="button" variant={destructive ? 'destructive' : 'default'} disabled={loading} onClick={() => void onConfirm()}>
            {loading ? <Loader2 className="animate-spin" /> : null}
            {confirmLabel ?? t('common.confirm')}
          </Button>
        </>
      }
    >
      {children}
    </Modal>
  )
}
